import { Omit, With } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { z } from 'zod';
import { WiseTransfer } from './wise.transfer.entity';

export class CreateWiseTransferDto extends With(
    Omit(WiseTransfer, [...BaseEntityFieldsArray, 'transferId', 'wiseRecipientId', 'deduplicationId', 'profileId', 'status']),
    z.object({
        reference: z.string().nullish(),
        bankAccount: z.string().nullish(),
        entitiesIds: z.array(z.string()).optional(),
    }),
) {
    reference?: string;
    bankAccount?: string;
    entitiesIds?: string[];
}
